import { Grid, Typography } from '@material-ui/core';
import LoadingDimmer from 'app/components/LoadingDimmer';
import withStyles from '@material-ui/styles/withStyles';
import CloseIcon from '@material-ui/icons/Close';

const IntegrityAttachmentsPreview = ({
  classes,
  selectedAttachment,
  isLoading,
  resetPreviewState,
}) => {
  return (
    <>
      {isLoading && (
        <Grid item xs={12}>
          <LoadingDimmer />
        </Grid>
      )}
      {selectedAttachment.id && (
        <>
          <Grid item container xs={12} className={classes.header}>
            <Grid item xs={11} className={classes.title}>
              <Typography variant="h6">
                {selectedAttachment.fileName}
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.closeIcon}>
              <CloseIcon onClick={resetPreviewState} />
            </Grid>
          </Grid>
          <iframe
            src={selectedAttachment.filePath}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="File Preview"
          />
        </>
      )}
    </>
  );
};

const styles = (theme) => ({
  header: {
    background: theme.palette.table.row.main,
  },
  title: {
    padding: theme.spacing(2),
  },
  closeIcon: {
    padding: theme.spacing(2),
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default withStyles(styles)(IntegrityAttachmentsPreview);
